const fundraising = {
  validation_errors: 'Error validating team',
  ticketing: {
    title_required: 'Title is required',
    event_date_required: 'Event date is required',
    location_name_required: 'Location name is required',
    location_address_required: 'Location address is required',
    contact_name_required: 'Contact name is required',
    contact_phone_required: 'Contact phone is required',
    contact_email_required: 'Contact email is required',
    contact_email_invalid: 'Contact email must be a valid email',
    ticket_send_mode_required: 'Ticket send mode is required',
    ticket_send_mode_invalid: 'Ticket send mode is invalid',
  },
};
export default fundraising;
